import React, {useEffect, useState} from "react";
import {Divider, Image, Popover} from "antd";
import CloudApi from "../../../cloud/cloud_api";
import Message from "../../../common/message";

import white_arrow from "../../image/arrow/white_arrow.png";
import blue_arrow from "../../image/arrow/blue_arrow.png";
import excel from "../../image/file/excel.png";
import word from "../../image/file/word.png";
import ppt from "../../image/file/ppt.png";
import pdf from "../../image/file/pdf.png";
import txt from "../../image/file/txt.png";
import zip from "../../image/file/zip.png";
import image from "../../image/file/image.jpg";
import unknownFile from "../../image/messageList/unknownFile.png";
import Util from "../../../public/utils";
import audioPause from "../../iconfont/audio/audioPause.png";
import audioPlaying from "../../iconfont/audio/playing.gif";
import imLoading from "../../iconfont/loading/imLoading.gif";

const SingleMsg = (props) => {
    const {item, wxid, notSelf, reCallSocket, updateScroll, currentUrl, uploadFilesUrl, audioLoading, pageNum,getFileUrlList,index} = props

    const [fileSrc, setFileSrc] = useState('')
    const [redPoint, setRedPoint] = useState(true);

    useEffect(() => {
        if (currentUrl != undefined) return
        if (item.msgType == 15 || item.msgType == 23 || item.msgType == 16 || item.msgType == 103 || item.msgType == 14 || item.msgType == 101 || item.msgType == 102) {
            let bodyData = {
                msgId: item.msgData.msg_unique_identifier,
                wxid: wxid
            }
            CloudApi.getChatFileUrl(bodyData, data => {
                if (data.url) {
                    setFileSrc(data.url)
                    getFileUrlList({index: index, url: data.url})
                } else {
                    setFileSrc('noUrl')
                }
                if (updateScroll && pageNum == 1) {
                    updateScroll(500)
                }
            }, error => {
            })
        }
    }, [])


    const fileImg = (fileName) => {
        // console.log('9898', fileName)
        if (fileName.indexOf('txt') != -1) {
            return txt
        } else if (fileName.indexOf('ppt') != -1) {
            return ppt
        } else if (fileName.indexOf('doc') != -1) {
            return word
        } else if (fileName.indexOf('xlsx') != -1 || fileName.indexOf('xls') != -1 || fileName.indexOf('csv') != -1) {
            return excel
        } else if (fileName.indexOf('pdf') != -1) {
            return pdf
        } else if (fileName.indexOf('jpg') != -1 || fileName.indexOf('jpeg') != -1 || fileName.indexOf('png') != -1 || fileName.indexOf('gif') != -1) {
            return image
        } else if (fileName.indexOf('zip') != -1 || fileName.indexOf('rar') != -1 || fileName.indexOf('png') != -1 || fileName.indexOf('7z') != -1 || fileName.indexOf(' gzip') != -1 || fileName.indexOf(' tar.gz') != -1) {
            return zip
        } else {
            return unknownFile
        }
    }

    //撤回消息
    function retract(msg) {
        //wxid 跟 msgId
        // console.log('9898撤回的item', msg)
        let msgId = msg.msgData.msg_unique_identifier
        // if ((new Date() * 1 / 1000 - msg.msgData.timestamp) > 2 * 60) {
        //     return Message.warning('超过两分钟无法撤回')
        // }
        let contents = {
            msgId: msgId,
        }
        reCallSocket(contents)
    }

    //播放语音
    function onPlay(e) {
        //点了播放 走已读接口
        if (!item.audioHasListen) {
            let bodyData = {
                msgId: item.msgData.msg_unique_identifier,
                wxid: wxid,
            }
            CloudApi.chatAudioToListen(bodyData, data => {
                setRedPoint(false)
            })
        }
        //上面全部暂停， 再播放该次点击的
        let audio = e.currentTarget.getElementsByTagName('audio')[0];
        let audioImg = e.currentTarget.getElementsByClassName('audioImg')[0];
        let rnd = new Date() * 1;
        audio.setAttribute("zkplay", rnd);
        //只要点播放，先把所有的暂停
        let allAudios = document.getElementsByTagName('audio');
        let allAudioImgs = document.getElementsByClassName('audioImg');
        for (let i = 0; i < allAudios.length; i++) {
            let atzkplay = allAudios[i].getAttribute("zkplay");
            if (atzkplay == rnd) {
                continue;
            }
            allAudios[i].pause();
            allAudios[i].currentTime = 0
        }

        for (let i = 0; i < allAudioImgs.length; i++) {
            allAudioImgs[i].src = audioPause
        }

        // 改变播放/暂停图片
        if (audio.paused) {
            audio.play();
            audioImg.src = audioPlaying
        } else {
            audio.pause();
            audio.currentTime = 0
            audioImg.src = audioPause
        }
        audio.addEventListener('ended', () => {
            audioImg.src = audioPause
        }, false);
    }

    return (
        <>
            {
                React.Children.map(props.children, child => {
                    return React.cloneElement(child, {});
                })
            }
            {         /**
             * 2文本  6位置 14图片 23视频 15文件 13链接 41名片 26红包 29GIF 16语音 78小程序
             */}

            {/*{图片类型}*/}
            {
                item.msgType == 14 || item.msgType == 101 ?
                    <div className={'im-common'}>
                        {
                            uploadFilesUrl || currentUrl || fileSrc ?
                                <div>
                                    <Image
                                        preview={{src: (fileSrc || currentUrl || uploadFilesUrl) + '?x-oss-process=image/auto-orient,1/quality,q_80/format,webp'}}
                                        src={fileSrc || currentUrl || uploadFilesUrl}
                                        className={'im-img'}/>
                                    {
                                        item.loading != undefined ?
                                            <img src={imLoading}
                                                 className={'self_loading'}/> : ''
                                    }
                                </div> : ''
                        }
                    </div> : ''
            }

            {/*{视频类型}*/}
            {
                item.msgType == 23 || item.msgType == 103 ?
                    <div className={'im-common'}>
                        {
                            currentUrl || fileSrc || item.msgData.fileUrl ?
                                <div className={'im-video-max'}>
                                    <video controls
                                           className={'im-video'}>
                                        <source
                                            src={fileSrc || currentUrl || item.msgData.fileUrl}
                                            type="video/mp4"/>
                                        {/*<source src={item.msgData} type="video/ogg" />*/}
                                        您的浏览器不支持 视频播放。
                                    </video>
                                    {
                                        item.loading != undefined ?
                                            <img src={imLoading}
                                                 className={'self_loading'}/> : ''
                                    }
                                </div>
                                : ''
                        }
                    </div> : ''
            }

            {/*{音频类型}*/}
            {
                item.msgType == 16 ?
                    <div className={'im-common'}>
                        {
                            fileSrc ?
                                notSelf ?
                                    <div className={'im-audio-max'}
                                         onClick={onPlay}>
                                        <div className={'im-msg-not-self'}>
                                            <img src={white_arrow}
                                                 className={'not_self_arrow'}/>
                                            <audio>
                                                {/*<source src="horse.ogg" type="audio/ogg"/>*/}
                                                <source src={fileSrc}/>
                                                您的浏览器不支持 语音播放。
                                            </audio>
                                            <div className={'im-audio'}>
                                                <img src={audioPause}
                                                     style={{height: '15px'}}
                                                     className={'audioImg'}/>
                                            </div>
                                            {
                                                audioLoading.id == item.msgData.msg_unique_identifier && audioLoading.loading ?
                                                    <>
                                                        <Divider className={'im-audio-hr'}/>
                                                        <img src={imLoading} className={'im-audio-loading'}/>
                                                    </> :
                                                    item.translatedInfo != undefined ?
                                                        <>
                                                            <Divider className={'im-audio-hr'}/>
                                                            <span className={'im-audio-text'}
                                                                  onClick={e => e.stopPropagation()}>{item.translatedInfo || '无内容'}
                                                            </span>
                                                        </>
                                                        : ''
                                            }
                                        </div>
                                        <div className={'time-and-point-max'}>
                                            <div className={'audio-red-point'}
                                                 style={{visibility: item.audioHasListen || item.translatedInfo ? 'hidden' : redPoint ? '' : 'hidden'}}>
                                            </div>
                                            <span className={'audio-time-point'}>
                                                {`${item.msgData.duration}`}
                                                <span style={{fontFamily: 'auto'}}>''</span>
                                            </span>
                                        </div>
                                    </div>
                                    :
                                    <div className={'im-audio-max'}
                                         onClick={onPlay}>
                                        <div className={'time-and-point-max'} style={{alignItems: 'flex-end'}}>
                                            <div className={'audio-red-point-self'}
                                                 style={{visibility: item.audioHasListen || item.translatedInfo ? 'hidden' : redPoint ? '' : 'hidden'}}>
                                            </div>
                                            <span className={'audio-time-point-self'}>
                                                {`${item.msgData.duration}`}
                                                <span style={{fontFamily: 'auto'}}>''</span>
                                            </span>
                                        </div>
                                        <div className={'im-msg'}>
                                            <img src={blue_arrow}
                                                 className={'self_arrow'}/>
                                            <audio>
                                                {/*<source src="horse.ogg" type="audio/ogg"/>*/}
                                                <source src={fileSrc}/>
                                                您的浏览器不支持 语音播放。
                                            </audio>
                                            <div className={'im-audio turn-out'}>
                                                <img src={audioPause}
                                                     style={{height: '15px'}}
                                                     className={'audioImg'}/>
                                                {
                                                    audioLoading.id == item.msgData.msg_unique_identifier && audioLoading.loading ?
                                                        <>
                                                            <Divider className={'im-audio-hr-self'}/>
                                                            <img src={imLoading} className={'im-audio-loading'}/>
                                                        </> :
                                                        item.translatedInfo != undefined ?
                                                            <>
                                                                <Divider className={'im-audio-hr-self'}/>
                                                                <span className={'im-audio-text'}
                                                                      onClick={e => e.stopPropagation()}>{item.translatedInfo || '无内容'}
                                                            </span>
                                                            </>
                                                            : ''
                                                }
                                            </div>
                                        </div>
                                    </div> : ''
                        }
                    </div> : ''
            }

            {/*{文件类型}*/}
            {
                item.msgType == 15 || item.msgType == 102 ?
                    <div className={'im-common'}>
                        {
                            notSelf ?
                                <a className={'im-msg-file'}
                                   // href={fileSrc || item.msgData.fileUrl}
                                   // download={item.msgData.file_name}
                                   target={'_blank'}>
                                    <img src={white_arrow}
                                         className={'not_self_arrow'}/>
                                    <img src={fileImg(item.msgData.file_name)}/>
                                    <div
                                        className={'unknownFile-right'}>
                                        <span>{item.msgData.file_name}</span>
                                        <div>{Util.fileSizeToString(item.msgData.file_size)}</div>
                                    </div>
                                </a> :
                                <a className={'im-msg-file'}
                                   // href={fileSrc || currentUrl || item.msgData.fileUrl}
                                   // download={item.msgData.file_name}
                                   target={'_blank'}>
                                    <img src={white_arrow}
                                         className={'self_arrow_trans'}/>
                                    <img src={fileImg(item.msgData.file_name)}/>
                                    <div
                                        className={'unknownFile-right'}>
                                        <span>{item.msgData.file_name}</span>
                                        <div>{Util.fileSizeToString(item.msgData.file_size)}</div>
                                    </div>
                                    {
                                        item.loading != undefined ?
                                            <img src={imLoading}
                                                 className={'self_loading'}/> : ''
                                    }
                                </a>
                        }
                    </div> : ''
            }
        </>
    )
}
export default SingleMsg